import { useMemo } from "react";
import { useAuthStore } from "../hooks";
import { AuthStatus, RoutesMap } from "../types";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Role } from "../types/roles/roleTypes";

interface IRestrictedRouteProps {
  pathRequired: RoutesMap;
}

export const RestrictedRoute = (props: IRestrictedRouteProps) => {
  const { pathRequired } = props;
  //Hooks
  const { user, status } = useAuthStore();
  const location = useLocation();

  // const hasAccess = user?.views?.some((view) =>
  //   pathRequired.includes(view.url_event)
  // );

  const hasAccess = useMemo(() => {
    if (user.userType === Role.ADMIN) {
      return true;
    }
    if (user.userType === Role.AGENT) {
      const views = [
        RoutesMap.REWARDS,
        RoutesMap.REWARDSTUDENT,
        RoutesMap.REWARDSTUDENTDETAIL,
      ];
      return views.some((view) => pathRequired.includes(view));
    }
  }, [user]);

  return hasAccess ? (
    <Outlet />
  ) : status === AuthStatus.AUTHENTICATED ? (
    <Navigate to="/404" state={{ from: location }} replace />
  ) : (
    <Navigate to={RoutesMap.LOGIN} state={{ from: location }} replace />
  );
};
